import { CloseButton, P2GBox, useP2GMediaQueryUp } from '@parcel2go/core-ui';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface DrawerWrapperProps {
  children: ReactNode;
  onClose?: () => void;
}

export const DrawerWrapper = ({ children, onClose }: DrawerWrapperProps) => {
  const { t } = useTranslation([TranslationNamespaces.QUOTE]);
  const isDesktop = useP2GMediaQueryUp('md');

  if (isDesktop) {
    return (
      <P2GBox width="455px" p={2} dataTestId="service-drawer">
        <P2GBox display="flex" justifyContent="flex-end" alignItems="flex-end">
          <CloseButton
            closeButtonText={t('CLOSE_BUTTON', { defaultValue: 'Close' })}
            handleOnClose={onClose}
            dataTestId="drawer-close-button"
          />
        </P2GBox>
        {children}
      </P2GBox>
    );
  }
  return (
    <P2GBox
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '95%',
        height: '95%',
        bgcolor: 'background.default',
        border: '1px solid #000',
        borderRadius: '10px',
        overflow: 'hidden auto'
      }}
      dataTestId="service-modal"
    >
      <P2GBox
        p={2}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' }
        }}
      >
        <P2GBox display="flex" justifyContent="flex-end" alignItems="flex-end">
          <CloseButton
            closeButtonText={t('CLOSE_BUTTON', { defaultValue: 'Close' })}
            handleOnClose={onClose}
            dataTestId="modal-close-button"
          />
        </P2GBox>
        {children}
      </P2GBox>
    </P2GBox>
  );
};
